export const useRoute = window.route

export const useQueryParam = () =>
  Object.fromEntries(new URLSearchParams(window.location.search).entries())

/**
 * Sets (or with `null` removes) one query parameter of the current URL without an Inertia visit,
 * keeping the history state, so a tab or a selected record has its own address.
 *
 * @param {string} name
 * @param {string|null} value
 */
export const replaceQueryParam = (name, value) => {
  const url = new URL(window.location.href)

  if (value === null) {
    url.searchParams.delete(name)
  } else {
    url.searchParams.set(name, value)
  }

  window.history.replaceState(window.history.state, '', url)
}

export const useUrlWithQuery = (route, query) =>
  `${route}?${new URLSearchParams(query).toString()}`

export const openToNewTab = (url) => {
  window.open(url, '_blank')
}
